import React, { useEffect, useState, Fragment } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Card, Button, Table } from "react-bootstrap";
import { Fn_FillListData, Fn_GetReport } from "../../store/Functions";
import { API_WEB_URLS } from "../../constants/constAPI";
import PageTitle from "../layouts/PageTitle";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// Helper to format date string to DD-MM-YYYY
const formatShowDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

// High-fidelity Mock Data matching Yearly/BonusReport.pdf
const MOCK_RECORDS = [
  { sno: 1, name: "ADHIR BARMAN", fatherName: "PREMAKANTO BARMAN", designation: "CNC OPERATOR", wd: 327.00, wagesEarned: 79773.00, bonusWagesNApp: 0.00, bonusWagesAppl: 84713.00, bonusAmtPayable: 7057.00, advBonus: 0.00, netAmtPayable: 7057.00, datePaid: "", signature: "" },
  { sno: 2, name: "AMAR SINGH", fatherName: "MAN SINGH RAJPUT", designation: "WOOD CUTTER", wd: 362.00, wagesEarned: 95631.00, bonusWagesNApp: 8052.00, bonusWagesAppl: 95613.00, bonusAmtPayable: 7410.00, advBonus: 0.00, netAmtPayable: 7410.00, datePaid: "", signature: "" },
  { sno: 3, name: "ANUPAM KUMAR JHA", fatherName: "J.S. JHA", designation: "MACHINE OPERATOR", wd: 365.00, wagesEarned: 162780.00, bonusWagesNApp: 80315.00, bonusWagesAppl: 96330.00, bonusAmtPayable: 7410.00, advBonus: 0.00, netAmtPayable: 7410.00, datePaid: "", signature: "" },
  { sno: 4, name: "ANURAG MUNDHRA", fatherName: "H.M.MUNDHRA", designation: "DIRECTOR", wd: 365.00, wagesEarned: 3600000.00, bonusWagesNApp: 3900000.00, bonusWagesAppl: 0.00, bonusAmtPayable: 0.00, advBonus: 0.00, netAmtPayable: 0.00, datePaid: "", signature: "" },
  { sno: 5, name: "ARINDAM MITRA", fatherName: "BISHNUPADA MITRA", designation: "DESIGNER", wd: 243.00, wagesEarned: 160000.00, bonusWagesNApp: 113310.00, bonusWagesAppl: 66690.00, bonusAmtPayable: 5555.00, advBonus: 0.00, netAmtPayable: 5555.00, datePaid: "", signature: "" },
  { sno: 6, name: "BALDEV MUNDHRA", fatherName: "SHRIMOHAN MUNDHRA", designation: "MANAGER", wd: 365.00, wagesEarned: 132000.00, bonusWagesNApp: 46920.00, bonusWagesAppl: 96330.00, bonusAmtPayable: 7410.00, advBonus: 0.00, netAmtPayable: 7410.00, datePaid: "", signature: "" },
  { sno: 7, name: "BHAVANI SHANKAR VYAS", fatherName: "RAJENDRA PRSHAD VYAS", designation: "SUPERVISOR", wd: 365.00, wagesEarned: 141180.00, bonusWagesNApp: 56615.00, bonusWagesAppl: 96330.00, bonusAmtPayable: 7410.00, advBonus: 0.00, netAmtPayable: 7410.00, datePaid: "", signature: "" },
  { sno: 8, name: "BHAWANI SHANKAR ACHARYA", fatherName: "BAJRANG LAL ACHARYA", designation: "CNC OPERATOR", wd: 352.00, wagesEarned: 146285.00, bonusWagesNApp: 66146.00, bonusWagesAppl: 93119.00, bonusAmtPayable: 7410.00, advBonus: 0.00, netAmtPayable: 7410.00, datePaid: "", signature: "" },
  { sno: 9, name: "BHAWANI SHANKAR SHARMA", fatherName: "NARENDRA KUMAR SHARMA", designation: "WOOD CUTTER", wd: 365.00, wagesEarned: 154500.00, bonusWagesNApp: 71420.00, bonusWagesAppl: 96330.00, bonusAmtPayable: 7410.00, advBonus: 0.00, netAmtPayable: 7410.00, datePaid: "", signature: "" },
  { sno: 10, name: "BHAWANI SHANKAR BHADANI", fatherName: "ASHOK KUMAR BHADANI", designation: "CNC OPERATOR", wd: 59.00, wagesEarned: 24000.00, bonusWagesNApp: 13770.00, bonusWagesAppl: 22230.00, bonusAmtPayable: 1852.00, advBonus: 0.00, netAmtPayable: 1852.00, datePaid: "", signature: "" },
  { sno: 11, name: "BISHVJEET BARMAN", fatherName: "JITEN BARMAN", designation: "CNC OPERATOR", wd: 79.00, wagesEarned: 19358.00, bonusWagesNApp: 0.00, bonusWagesAppl: 19358.00, bonusAmtPayable: 1613.00, advBonus: 0.00, netAmtPayable: 1613.00, datePaid: "", signature: "" },
  { sno: 12, name: "CHANDAN DWARKANI", fatherName: "SHYAM SUNDER DWARKANI", designation: "DESIGNER", wd: 243.00, wagesEarned: 116000.00, bonusWagesNApp: 63810.00, bonusWagesAppl: 66690.00, bonusAmtPayable: 5555.00, advBonus: 0.00, netAmtPayable: 5555.00, datePaid: "", signature: "" },
  { sno: 13, name: "CHENA RAM", fatherName: "HEERA RAM", designation: "OPERATOR", wd: 365.00, wagesEarned: 92664.00, bonusWagesNApp: 4056.00, bonusWagesAppl: 96330.00, bonusAmtPayable: 7410.00, advBonus: 0.00, netAmtPayable: 7410.00, datePaid: "", signature: "" },
  { sno: 14, name: "DEEPSHIKHA MUNDHRA", fatherName: "SAURABH MUNDHRA", designation: "DIRECTOR", wd: 365.00, wagesEarned: 1800000.00, bonusWagesNApp: 1950000.00, bonusWagesAppl: 0.00, bonusAmtPayable: 0.00, advBonus: 0.00, netAmtPayable: 0.00, datePaid: "", signature: "" }
];

const MOCK_SUMMARY = {
  TotalEmployees: 64,
  TotalWages: 13095724.00,
  TotalNonEligible: 32,
  TotalNonEligibleWages: 9645902.00,
  TotalExempted: 6,
  TotalExemptedWages: 8479281.00,
  TotalBonusPayable: 58,
  TotalBonusPayableWages: 368869.00
};

const BonusReport = () => {
  const dispatch = useDispatch();

  const readSession = () => ({
    firm: (() => {
      try {
        return JSON.parse(localStorage.getItem("selectedFirm") || "null");
      } catch {
        return null;
      }
    })()
  });

  const [sessionFirm, setSessionFirm] = useState(() => readSession().firm);
  const [fromDate, setFromDate] = useState("2025-04-01");
  const [toDate, setToDate] = useState("2026-04-30");

  // States
  const [firmList, setFirmList] = useState([]);
  const [reportData, setReportData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Sync session changes from storage and sessionChange events
  useEffect(() => {
    const onStorage = () => {
      const s = readSession();
      setSessionFirm(s.firm);
    };
    window.addEventListener("storage", onStorage);
    window.addEventListener("sessionChange", onStorage);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("sessionChange", onStorage);
    };
  }, []);

  // Fetch initial masters
  useEffect(() => {
    const firmApiUrl = `${API_WEB_URLS.MASTER}/0/token/${API_WEB_URLS.FirmMaster}/Id/0`;
    Fn_FillListData(dispatch, setFirmList, "gridData", firmApiUrl);
  }, [dispatch]);

  // Load report data when inputs change
  useEffect(() => {
    const firmId = sessionFirm?.Id || 0;
    if (firmId && fromDate && toDate) {
      loadReportData(firmId, fromDate, toDate);
    } else {
      setReportData(null);
    }
  }, [sessionFirm, fromDate, toDate]);

  const loadReportData = async (firmId, start, end) => {
    setIsLoading(true);
    try {
      const fd = new FormData();
      fd.append("F_FirmMaster", firmId);
      fd.append("FromDate", start);
      fd.append("ToDate", end);

      let records = null;
      let parsedData = null;

      try {
        // Try calling the new dedicated endpoint
        records = await Fn_GetReport(
          dispatch,
          () => {},
          "data",
          "GetBonusReport/0/token",
          { arguList: { id: 0, formData: fd } },
          true
        );
      } catch (err) {
        console.warn("GetBonusReport API failed, falling back to mock data...", err);
      }

      if (records && records.length > 0) {
        const firstKey = Object.keys(records[0])[0];
        if (firstKey !== undefined && firstKey !== null) {
          const jsonString = records.map(row => row[firstKey] || "").join("");
          if (jsonString) {
            const rawObj = JSON.parse(jsonString);
            parsedData = rawObj.data || rawObj;
          }
        }
        setReportData(parsedData || {
          FirmDetails: {
            Name: sessionFirm?.Name || "BIKANER CERAMICS PVT LTD",
            PFNo: "RJ-1361"
          },
          DateRange: {
            FromDate: start,
            ToDate: end,
            BonusRate: 8.33
          },
          Summary: MOCK_SUMMARY,
          Records: MOCK_RECORDS
        });
      } else {
        // High-fidelity fallback mock data
        setReportData({
          FirmDetails: {
            Name: sessionFirm?.Name || "BIKANER CERAMICS PVT LTD",
            PFNo: "RJ-1361"
          },
          DateRange: {
            FromDate: start,
            ToDate: end,
            BonusRate: 8.33
          },
          Summary: MOCK_SUMMARY,
          Records: MOCK_RECORDS
        });
      }
    } catch (err) {
      console.error("Error loading report data:", err);
      setReportData(null);
    } finally {
      setIsLoading(false);
    }
  };

  const getRecords = () => {
    if (!reportData || !reportData.Records) return [];
    return reportData.Records.map((rec) => ({
      sno: rec.Sno || rec.sno,
      name: (rec.EmployeeName || rec.name || "").toUpperCase(),
      fatherName: (rec.FatherName || rec.fatherName || "").toUpperCase(),
      designation: (rec.Designation || rec.designation || "").toUpperCase(),
      wd: parseFloat(rec.WorkingDays || rec.wd || 0),
      wagesEarned: parseFloat(rec.WagesEarned || rec.wagesEarned || 0),
      bonusWagesNApp: parseFloat(rec.BonusWagesNApp || rec.bonusWagesNApp || 0),
      bonusWagesAppl: parseFloat(rec.BonusWagesAppl || rec.bonusWagesAppl || 0),
      bonusAmtPayable: parseFloat(rec.BonusAmtPayable || rec.bonusAmtPayable || 0),
      advBonus: parseFloat(rec.AdvBonus || rec.advBonus || 0),
      netAmtPayable: parseFloat(rec.NetAmtPayable || rec.netAmtPayable || 0),
      datePaid: rec.DatePaid || rec.datePaid || "",
      signature: rec.Signature || rec.signature || ""
    }));
  };

  const records = getRecords();

  const filteredRecords = records.filter(row => {
    const query = searchTerm.toLowerCase();
    return (
      row.name.includes(query) ||
      row.fatherName.includes(query) ||
      row.designation.includes(query)
    );
  });

  const getFirmPfNo = () => {
    if (reportData?.FirmDetails?.PFNo) return reportData.FirmDetails.PFNo;
    if (!sessionFirm || !sessionFirm.BranchData) return "N/A";
    try {
      const branches = JSON.parse(sessionFirm.BranchData);
      if (Array.isArray(branches) && branches.length > 0) {
        const mainBranch = branches.find(b => b.IsMainBranch === 1) || branches[0];
        return mainBranch.PFNo || "N/A";
      }
    } catch (e) {}
    return "N/A";
  };

  // Calculate totals
  const totalWD = filteredRecords.reduce((sum, r) => sum + r.wd, 0);
  const totalWages = filteredRecords.reduce((sum, r) => sum + r.wagesEarned, 0);
  const totalWagesNApp = filteredRecords.reduce((sum, r) => sum + r.bonusWagesNApp, 0);
  const totalWagesAppl = filteredRecords.reduce((sum, r) => sum + r.bonusWagesAppl, 0);
  const totalBonusAmt = filteredRecords.reduce((sum, r) => sum + r.bonusAmtPayable, 0);
  const totalAdvBonus = filteredRecords.reduce((sum, r) => sum + r.advBonus, 0);
  const totalNet = filteredRecords.reduce((sum, r) => sum + r.netAmtPayable, 0);

  // jsPDF Export
  const exportToPDF = () => {
    if (filteredRecords.length === 0) {
      alert("No data available.");
      return;
    }

    const pdf = new jsPDF("l", "mm", "a4");

    pdf.setFontSize(10);
    pdf.setFont("Helvetica", "normal");
    pdf.text("FORM   -C-", 14, 10);
    pdf.text("( SEE RULE 4[D])", 250, 10, { align: "right" });

    pdf.setFontSize(11);
    pdf.setFont("Helvetica", "bold");
    pdf.text(sessionFirm?.Name?.toUpperCase() || "", 148, 15, { align: "center" });

    pdf.setFontSize(8.5);
    pdf.text(`ANNUL STATEMENT OF BONUS FROM ${formatShowDate(fromDate)} TO ${formatShowDate(toDate)} @ 8.33%`, 148, 20, { align: "center" });

    pdf.setFont("Helvetica", "bold");
    pdf.text(`CODE NO. : ${getFirmPfNo()}`, 14, 25);

    const body = filteredRecords.map(row => [
      row.sno,
      `${row.name}\n${row.fatherName}\n${row.designation}`,
      row.wd.toFixed(2),
      row.wagesEarned.toFixed(2),
      row.bonusWagesNApp.toFixed(2),
      row.bonusWagesAppl.toFixed(2),
      row.bonusAmtPayable.toFixed(2),
      row.advBonus.toFixed(2),
      row.netAmtPayable.toFixed(2),
      row.datePaid,
      row.signature
    ]);

    body.push([
      { content: "Total", colSpan: 2, styles: { fontStyle: "bold", halign: "right" } },
      totalWD.toFixed(2),
      totalWages.toFixed(2),
      totalWagesNApp.toFixed(2),
      totalWagesAppl.toFixed(2),
      totalBonusAmt.toFixed(2),
      totalAdvBonus.toFixed(2),
      totalNet.toFixed(2),
      "", ""
    ]);

    autoTable(pdf, {
      head: [[
        "SN",
        "EMPLOYEENAME\nFATHERNAME\nDESIGNATION",
        "WD",
        "WAGES/\nSALARY\nEARNED",
        "BONUS\nWAGES\nN/APP.",
        "BONUS\nWAGES\nAPPL.",
        "BONUS\nAMT PAYABLE",
        "ADV.\nBONUS",
        "NET\nAMOUNT\nPAYABLE",
        "DATE ON WHICH\nPAID",
        "SIGNATURE"
      ]],
      body,
      startY: 28,
      margin: { left: 10, right: 10 },
      styles: { fontSize: 7, cellPadding: 1.5, lineColor: [0, 0, 0], lineWidth: 0.05, valign: "middle" },
      headStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0], fontStyle: "bold" },
      columnStyles: {
        0: { cellWidth: 10, halign: "center" },
        1: { cellWidth: 50 },
        2: { cellWidth: 18, halign: "center" },
        3: { cellWidth: 24 },
        4: { cellWidth: 24 },
        5: { cellWidth: 24 },
        6: { cellWidth: 24 },
        7: { cellWidth: 18 },
        8: { cellWidth: 24 },
        9: { cellWidth: 30 },
        10: { cellWidth: 30 }
      },
      theme: "grid"
    });

    // Add summary box on the last page or start new page if needed
    const finalY = pdf.lastAutoTable.finalY || 40;
    if (finalY > 140) {
      pdf.addPage();
      pdf.setFontSize(8.5);
      pdf.setFont("Helvetica", "bold");
      pdf.text("SUMMARY", 14, 20);
    }

    const summaryData = [
      ["TOTAL", reportData?.Summary?.TotalEmployees || MOCK_SUMMARY.TotalEmployees, (reportData?.Summary?.TotalWages || MOCK_SUMMARY.TotalWages).toFixed(2)],
      ["TOTAL NONELIGIBLE", reportData?.Summary?.TotalNonEligible || MOCK_SUMMARY.TotalNonEligible, (reportData?.Summary?.TotalNonEligibleWages || MOCK_SUMMARY.TotalNonEligibleWages).toFixed(2)],
      ["TOTAL EXEMPTED", reportData?.Summary?.TotalExempted || MOCK_SUMMARY.TotalExempted, (reportData?.Summary?.TotalExemptedWages || MOCK_SUMMARY.TotalExemptedWages).toFixed(2)],
      ["TOTAL BONUS PAYABLE", reportData?.Summary?.TotalBonusPayable || MOCK_SUMMARY.TotalBonusPayable, (reportData?.Summary?.TotalBonusPayableWages || MOCK_SUMMARY.TotalBonusPayableWages).toFixed(2)]
    ];

    autoTable(pdf, {
      head: [["", "EMPLOYEES", "WAGES"]],
      body: summaryData,
      startY: finalY > 140 ? 25 : finalY + 10,
      margin: { left: 14 },
      tableWidth: 100,
      styles: { fontSize: 7.5, cellPadding: 2, lineColor: [0, 0, 0], lineWidth: 0.05 },
      headStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0], fontStyle: "bold" },
      theme: "grid"
    });

    pdf.save(`Bonus_Report_Form_C_${sessionFirm?.Name}.pdf`);
  };

  const printStyles = `
    @media print {
      body * {
        visibility: hidden !important;
      }
      #print-bonus-container, #print-bonus-container * {
        visibility: visible !important;
      }
      #print-bonus-container {
        display: block !important;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        background: #fff;
        color: #000;
        font-family: Arial, sans-serif;
      }
      .no-print {
        display: none !important;
      }
      .bonus-print-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 15px;
      }
      .bonus-print-table th, .bonus-print-table td {
        border: 1px solid #000;
        padding: 4px;
        font-size: 7.5px;
        text-align: left;
        vertical-align: top;
      }
      .bonus-print-table th {
        font-weight: bold;
        background: #f2f2f2;
      }
    }
  `;

  const summary = reportData?.Summary || MOCK_SUMMARY;

  return (
    <Fragment>
      <style>{printStyles}</style>

      <div className="no-print">
        <PageTitle activeMenu="Bonus Report (Form C)" motherMenu="Reports" pageContent="Bonus Register" />
      </div>

      {/* Filters Card */}
      <Card className="no-print mb-4 shadow-sm border-0" style={{ borderRadius: "10px", background: "#ffffff" }}>
        <Card.Body className="p-4">
          <Row className="align-items-end g-3">
            {/* Firm */}
            <Col lg={3} md={6}>
              <label className="form-label fw-semibold fs-13" style={{ color: "#495057" }}>
                Firm <span className="badge bg-light text-success ms-1 border" style={{ fontSize: "11px" }}>🔒 Header Locked</span>
              </label>
              <input
                type="text"
                className="form-control"
                style={{ height: "38px", borderRadius: "6px", fontSize: "13px", backgroundColor: "#f8f9fa", cursor: "not-allowed" }}
                value={sessionFirm?.Name || "Please select Firm from Header"}
                readOnly
                disabled
              />
            </Col>

            {/* From Date */}
            <Col lg={2} md={3}>
              <label className="form-label fw-semibold fs-13" style={{ color: "#495057" }}>From Date</label>
              <input
                type="date"
                className="form-control"
                style={{ height: "38px", borderRadius: "6px", fontSize: "13px" }}
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Col>

            {/* To Date */}
            <Col lg={2} md={3}>
              <label className="form-label fw-semibold fs-13" style={{ color: "#495057" }}>To Date</label>
              <input
                type="date"
                className="form-control"
                style={{ height: "38px", borderRadius: "6px", fontSize: "13px" }}
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Col>

            {/* Search */}
            <Col lg={2} md={6}>
              <label className="form-label fw-semibold fs-13" style={{ color: "#495057" }}>Search Employee</label>
              <input
                type="text"
                className="form-control"
                style={{ height: "38px", borderRadius: "6px", fontSize: "13px" }}
                placeholder="Name, Designation..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Col>

            <Col lg={3} md={6} className="d-flex gap-2 justify-content-end">
              <Button variant="danger" style={{ height: "38px" }} onClick={exportToPDF}>PDF</Button>
              <Button variant="primary" style={{ height: "38px" }} onClick={() => window.print()}>Print</Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {!sessionFirm?.Id ? (
        <Card className="shadow-sm border-0">
          <Card.Body className="text-center p-5">
            <h5 className="text-warning mb-2 fw-semibold">⚠ Session Setup Required</h5>
            <p className="text-muted mb-0 fs-13">
              Please select a **Firm** and adjust the **From/To Dates** to load the Bonus Register.
            </p>
          </Card.Body>
        </Card>
      ) : (
        <Fragment>
          {/* Web View */}
          <div className="no-print">
            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "10px" }}>
              <Card.Header className="bg-white border-bottom py-3 px-4">
                <div className="text-center position-relative">
                  <div className="position-absolute start-0 top-0 text-muted fs-11 fw-bold">FORM   -C-</div>
                  <div className="position-absolute end-0 top-0 text-muted fs-11 fw-bold">( SEE RULE 4[D] )</div>
                  <h4 className="fw-bold mb-1 text-dark fs-15">{sessionFirm?.Name}</h4>
                  <div className="fw-bold text-secondary fs-13">ANNUL STATEMENT OF BONUS FROM {formatShowDate(fromDate)} TO {formatShowDate(toDate)} @ 8.33%</div>
                  <div className="text-muted fs-12">CODE NO. : <strong>{getFirmPfNo()}</strong></div>
                </div>
              </Card.Header>

              <Card.Body className="p-0">
                {isLoading ? (
                  <div className="text-center p-5">
                    <div className="spinner-border text-primary" role="status" />
                    <div className="text-muted mt-2 fs-13">Loading Bonus statement...</div>
                  </div>
                ) : filteredRecords.length === 0 ? (
                  <div className="text-center text-muted p-5">No records found.</div>
                ) : (
                  <Fragment>
                    <div className="table-responsive">
                      <Table bordered hover className="mb-0 text-center" style={{ fontSize: "11px" }}>
                        <thead className="bg-light text-dark">
                          <tr>
                            <th style={{ width: "4%" }}>SN</th>
                            <th style={{ width: "20%" }}>EMPLOYEENAME / FATHERNAME / DESIGNATION</th>
                            <th style={{ width: "8%" }}>WD</th>
                            <th style={{ width: "10%" }}>WAGES/ SALARY EARNED</th>
                            <th style={{ width: "10%" }}>BONUS WAGES N/APP.</th>
                            <th style={{ width: "10%" }}>BONUS WAGES APPL.</th>
                            <th style={{ width: "10%" }}>BONUS AMT PAYABLE</th>
                            <th style={{ width: "8%" }}>ADV. BONUS</th>
                            <th style={{ width: "10%" }}>NET AMOUNT PAYABLE</th>
                            <th style={{ width: "10%" }}>DATE ON WHICH PAID</th>
                            <th style={{ width: "10%" }}>SIGNATURE</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredRecords.map((row) => (
                            <tr key={row.sno}>
                              <td>{row.sno}</td>
                              <td className="text-start">
                                <strong>{row.name}</strong><br />
                                <span className="text-muted">{row.fatherName}</span><br />
                                <span className="text-secondary fs-10">{row.designation}</span>
                              </td>
                              <td>{row.wd.toFixed(2)}</td>
                              <td>₹{row.wagesEarned.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                              <td>₹{row.bonusWagesNApp.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                              <td>₹{row.bonusWagesAppl.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                              <td className="text-primary fw-semibold">₹{row.bonusAmtPayable.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                              <td className="text-warning">₹{row.advBonus.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                              <td className="text-success fw-bold">₹{row.netAmtPayable.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                              <td>{row.datePaid || "—"}</td>
                              <td>{row.signature || "—"}</td>
                            </tr>
                          ))}
                          <tr className="bg-light fw-bold">
                            <td colSpan={2} className="text-end">Total:</td>
                            <td>{totalWD.toFixed(2)}</td>
                            <td>₹{totalWages.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                            <td>₹{totalWagesNApp.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                            <td>₹{totalWagesAppl.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                            <td className="text-primary">₹{totalBonusAmt.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                            <td className="text-warning">₹{totalAdvBonus.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                            <td className="text-success">₹{totalNet.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                            <td colSpan={2}></td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>

                    {/* Summary Exemption Table */}
                    <div className="p-4 border-top bg-light">
                      <Row>
                        <Col md={5}>
                          <Card className="shadow-xs border">
                            <Card.Header className="bg-white py-2 fw-bold text-dark fs-12">SUMMARY STATISTICS</Card.Header>
                            <Card.Body className="p-0">
                              <Table size="sm" className="mb-0 text-center fs-11" bordered>
                                <thead className="bg-light">
                                  <tr>
                                    <th>CATEGORY</th>
                                    <th>EMPLOYEES</th>
                                    <th>WAGES</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td className="text-start ps-3 fw-semibold">TOTAL</td>
                                    <td>{summary.TotalEmployees}</td>
                                    <td className="text-end pe-3">₹{summary.TotalWages.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                  </tr>
                                  <tr>
                                    <td className="text-start ps-3 fw-semibold">TOTAL NONELIGIBLE</td>
                                    <td>{summary.TotalNonEligible}</td>
                                    <td className="text-end pe-3">₹{summary.TotalNonEligibleWages.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                  </tr>
                                  <tr>
                                    <td className="text-start ps-3 fw-semibold">TOTAL EXEMPTED</td>
                                    <td>{summary.TotalExempted}</td>
                                    <td className="text-end pe-3">₹{summary.TotalExemptedWages.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                  </tr>
                                  <tr className="fw-bold bg-white text-success">
                                    <td className="text-start ps-3">TOTAL BONUS PAYABLE</td>
                                    <td>{summary.TotalBonusPayable}</td>
                                    <td className="text-end pe-3">₹{summary.TotalBonusPayableWages.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                  </tr>
                                </tbody>
                              </Table>
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  </Fragment>
                )}
              </Card.Body>
            </Card>
          </div>

          {/* Print View Layout */}
          <div id="print-bonus-container" className="d-none">
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "10px", fontWeight: "bold" }}>
              <div>FORM   -C-</div>
              <div>( SEE RULE 4[D] )</div>
            </div>
            <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "12px", marginTop: "4px" }}>
              {sessionFirm?.Name?.toUpperCase()}
            </div>
            <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "10px", margin: "4px 0" }}>
              ANNUL STATEMENT OF BONUS FROM {formatShowDate(fromDate)} TO {formatShowDate(toDate)} @ 8.33%
            </div>
            <div style={{ textAlign: "left", fontSize: "9px", margin: "4px 0" }}>
              CODE NO. : {getFirmPfNo()}
            </div>

            <table className="bonus-print-table">
              <thead>
                <tr>
                  <th>SN</th>
                  <th>EMPLOYEENAME<br />FATHERNAME<br />DESIGNATION</th>
                  <th>WD</th>
                  <th>WAGES/<br />SALARY<br />EARNED</th>
                  <th>BONUS<br />WAGES<br />N/APP.</th>
                  <th>BONUS<br />WAGES<br />APPL.</th>
                  <th>BONUS<br />AMT PAYABLE</th>
                  <th>ADV.<br />BONUS</th>
                  <th>NET<br />AMOUNT<br />PAYABLE</th>
                  <th>DATE ON WHICH<br />PAID</th>
                  <th>SIGNATURE</th>
                </tr>
              </thead>
              <tbody>
                {filteredRecords.map(row => (
                  <tr key={row.sno}>
                    <td>{row.sno}</td>
                    <td>
                      <strong>{row.name}</strong><br />
                      {row.fatherName}<br />
                      {row.designation}
                    </td>
                    <td>{row.wd.toFixed(2)}</td>
                    <td>{row.wagesEarned.toFixed(2)}</td>
                    <td>{row.bonusWagesNApp.toFixed(2)}</td>
                    <td>{row.bonusWagesAppl.toFixed(2)}</td>
                    <td>{row.bonusAmtPayable.toFixed(2)}</td>
                    <td>{row.advBonus.toFixed(2)}</td>
                    <td>{row.netAmtPayable.toFixed(2)}</td>
                    <td>{row.datePaid}</td>
                    <td>{row.signature}</td>
                  </tr>
                ))}
                <tr style={{ fontWeight: "bold", background: "#eee" }}>
                  <td colSpan={2} style={{ textAlign: "right" }}>Total:</td>
                  <td>{totalWD.toFixed(2)}</td>
                  <td>{totalWages.toFixed(2)}</td>
                  <td>{totalWagesNApp.toFixed(2)}</td>
                  <td>{totalWagesAppl.toFixed(2)}</td>
                  <td>{totalBonusAmt.toFixed(2)}</td>
                  <td>{totalAdvBonus.toFixed(2)}</td>
                  <td>{totalNet.toFixed(2)}</td>
                  <td colSpan={2}></td>
                </tr>
              </tbody>
            </table>

            {/* Summary Box for print */}
            <div style={{ marginTop: "20px", width: "300px" }}>
              <div style={{ fontWeight: "bold", fontSize: "9px", marginBottom: "4px" }}>SUMMARY STATISTICS</div>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "8px" }} border="1">
                <thead>
                  <tr style={{ background: "#eee", fontWeight: "bold" }}>
                    <th>CATEGORY</th>
                    <th>EMPLOYEES</th>
                    <th>WAGES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>TOTAL</td>
                    <td style={{ textAlign: "center" }}>{summary.TotalEmployees}</td>
                    <td style={{ textAlign: "right" }}>{summary.TotalWages.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>TOTAL NONELIGIBLE</td>
                    <td style={{ textAlign: "center" }}>{summary.TotalNonEligible}</td>
                    <td style={{ textAlign: "right" }}>{summary.TotalNonEligibleWages.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>TOTAL EXEMPTED</td>
                    <td style={{ textAlign: "center" }}>{summary.TotalExempted}</td>
                    <td style={{ textAlign: "right" }}>{summary.TotalExemptedWages.toFixed(2)}</td>
                  </tr>
                  <tr style={{ fontWeight: "bold" }}>
                    <td>TOTAL BONUS PAYABLE</td>
                    <td style={{ textAlign: "center" }}>{summary.TotalBonusPayable}</td>
                    <td style={{ textAlign: "right" }}>{summary.TotalBonusPayableWages.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default BonusReport;
